// extracted by mini-css-extract-plugin
export var elContainer = "EinzelLeistung-module--elContainer--U3C1W";
export var elImage = "EinzelLeistung-module--elImage--1OIbW";
export var elText = "EinzelLeistung-module--elText--DrdXw";
export var elTextContainer = "EinzelLeistung-module--elTextContainer--FCxp-";
export var elWrapper = "EinzelLeistung-module--elWrapper--6-bxd";